import styled from '@emotion/styled'
import { space, color, H4, device } from '@ticketswap/solar'

export const Block = styled.div`
  margin-bottom: ${space[32]};

  @media ${device.tablet} {
    margin-bottom: ${space[64]};
  }
`

export const BlockHeader = styled.header`
  margin-bottom: ${space[16]};
`

export const BlockSubtitle = styled(H4)`
  margin-top: ${space[4]};
  color: ${color.spaceMedium};
`
